import SettingTypes from '@/utils/setting-types'

export default {
  name: 'shop-header',
  label: {
    title: '店铺Header',
    icon: require('@/assets/icon-component-label_ShopHeader.svg'),
    limit: 1
  },
  tip: '注意：此模块只在店铺首页显示，微页面中不显示',
  decor_type: 'seller',
  sort: 2000,
  data: {
    bg_color: '#ffffff',
    bg_img: '',
    custom_logo: false,
    logo: '',
    custom_name: false,
    name: '',
    name_color: '#000000'
  },
  settings: {
    bg_color: {
      type: SettingTypes.color_picker,
      label: '背景色',
      default: '#ffffff'
    },
    bg_img: {
      type: SettingTypes.image,
      label: '背景图片'
    },
    custom_logo: {
      type: SettingTypes.boolean,
      label: '自定义LOGO'
    },
    logo: {
      type: SettingTypes.image,
      label: '上传LOGO',
      show: data => data.custom_logo
    },
    custom_name: {
      type: SettingTypes.boolean,
      label: '自定义名称'
    },
    name: {
      type: SettingTypes.input,
      label: '填写名称',
      show: data => data.custom_name
    },
    name_color: {
      type: SettingTypes.color_picker,
      label: '名称颜色',
      default: '#000000',
      show: data => data.custom_name
    }
  }
}
